import { render, staticRenderFns } from "./CustomFormRadioElement.vue?vue&type=template&id=32432e3e"
import script from "./CustomFormRadioElement.vue?vue&type=script&lang=js"
export * from "./CustomFormRadioElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports